
// 主色
export const PrimaryColor = '#EC6D2A';

